export default __webpack_public_path__ + "static/media/auth-image.81fc5b79.svg";